import * as Sentry from '@sentry/react';
import { appVersion, sentryDsn, env } from '~/env';

export const configureSentry = () => {
  Sentry.init({
    environment: env.VITE_APP_ENV,
    dsn: sentryDsn,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
      }),
    ],
    enabled: env.VITE_APP_ENV !== 'development',
    release: appVersion,
    attachStacktrace: true,
    normalizeDepth: 3,
    // Performance Monitoring
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: [env.VITE_API_URL],
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  });
};
